const state = {
    usuario: [],
    automatico: false,
    menu_idx: 0,
    filtros_chamado: {
        tabChamadosIdx: 0,
        data_ini: '',
        data_fin: '',
        situacao: '1',
        id_cliente: null,
        id_tec_inicial: null,
        id_tec_resp: null
    },
    tabChamadosIdx: 0,
    organizacao:"supogen"
}
const getters = {
    getUsuario: (state) => () => {
        return state.usuario;
    },
    getAutomatico: (state) => () => {
        return state.automatico;
    },
}
const mutations = {
    populaUsuario: (state, data) => {
        state.usuario = data;
    },
    populaAutomatico: (state, data) => {
        state.automatico = data;
    },
    setMenu: (state, data) => {
        state.menu_idx = data;
    },
    setFiltrosChamados: (state, data) => {
        state.filtros_chamado = data;
    },
}
const actions = {
    populaUsuario: ({ commit }, data) => {
        commit('populaUsuario', data);
    },
    populaAutomatico: ({ commit }, data) => {
        commit('populaAutomatico', data);
    },
    setMenu: ({ commit }, data) => {
        commit('setMenu', data);
    },
    setFiltrosChamados: ({ commit }, data) => {
        commit('setFiltrosChamados', data);
    },
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}